export function hexToRgb(hex: string) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (_m: string, r: string, g: string, b: string) {
    return r + r + g + g + b + b
  })

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null
}

export const hexToRgba = (hex: string, opacity: number) => {
  const rgb = hexToRgb(hex)
  return `rgba(${rgb?.r}, ${rgb?.g}, ${rgb?.b}, ${opacity})`
}
